import moment from "moment";
import { If } from "react-extras";
import { formatMoney } from "../../../../lib/format-money";
import React from "react";
import { ModalContentWrapper } from "./accept_advertisement_modal_helpers";
import {
  CampaignStyleHostRead,
  ProductExchangeTypeInstructions,
  ProductExchangeTypeMailing,
} from "../../../../constants/campaigns";
import ProductInstructionsInfo from "../product_instructions_info";

const AcceptedConfirmationContent = props => {
  const { campaign, campaignItem, creatorAmount } = props;

  const renderExchangeInfo = () => {
    if (campaign.style === CampaignStyleHostRead) return null;
    if (
      campaign.productExchangeType === ProductExchangeTypeInstructions &&
      campaign.productExchangeInstructions
    ) {
      return <ProductInstructionsInfo {...props} />;
    }
    if (campaign.productExchangeType === ProductExchangeTypeMailing) {
      return (
        <div>
          <div className="redcircle-form-label">Instructions for receiving product Samples</div>
          Brand will ship the product sample to the mailing address provided.
        </div>
      );
    }
  };
  return (
    <>
      <div>
        Congratulations, you did it! The audio promotion will begin running on your show’s episodes
        on <b>{moment.unix(campaignItem.startAt).format("LL")}</b>.{" "}
        <If condition={campaign?.targetingOptions.midRoll}>
          Make sure your new episodes and back catalog include mid-roll insertion points.
        </If>
      </div>
      <br />
      <div className={"m-bm"}>
        You will receive a total of <b>{formatMoney(creatorAmount)}</b> for running this ad campaign
        on your show. Payment schedule will be incremental and occurs once the advertiser completes
        payment, which can vary based on if the campaign is paid up front or invoiced. All campaign
        payments will be visible in your RedCircle account.
      </div>
      {renderExchangeInfo()}
    </>
  );
};
export const successPageConfig = props => {
  return {
    title: "Success!",
    closeOnly: true,
    closeText: "Done",

    Content: (
      <ModalContentWrapper>
        <AcceptedConfirmationContent {...props} />
      </ModalContentWrapper>
    ),
  };
};
